import { activeOnboarding } from '../activeOnboarding';
import type { SupportedFeatureIds } from '../types';

export const isOnboardingFeatureId = (id: string): id is SupportedFeatureIds =>
  id in activeOnboarding;
